module.exports = __webpack_public_path__ + "pc/img/rec_07.dee326aa.svg";